import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { totalUnreadIndicator } from '../../redux/channels/selectors'
import { createConnector, InferConnectedProps } from '../../redux/createConnector'
import { unreadTaskCount } from '../../redux/myTasks/selectors'
import { toggleNotes } from '../../redux/notes/actions'
import { toggleSidebar, logout } from '../../redux/profile/actions'
import {
  isClientUser,
  isDueDiligenceClient,
  isSidebarOpen,
  user,
  clientInfo,
  role,
  isPastClient,
  isAdminLoggedAsClient,
} from '../../redux/profile/selectors'
import { favoriteProjects } from '../../redux/taskProjects/selectors'
import { title } from '../../redux/ui/selectors'
import SideMenu, { IProps } from './SideMenu'

const selector = createStructuredSelector({
  role,
  isSidebarOpen,
  isPastClient,
  isDueDiligenceClient,
  isAdminLoggedAsClient,
  isClientUser,
  user,
  clientInfo,
  title,
  totalUnreadIndicator,
  unreadTaskCount,
  favoriteProjects,
})

const actions = {
  onLogout: logout,
  toggleSidebar,
  toggleNotes,
}

const connector = connect(selector, actions)
export type PropsFromRedux = InferConnectedProps<typeof connector, typeof actions>
export default createConnector<typeof connector, IProps, PropsFromRedux>(connector, SideMenu)
